module.exports = function() {
  return new Worker(__webpack_public_path__ + "108a02a23d4fd7d50368.worker.js");
};